export function formatPhone(phone: string | number | undefined | null) {
  if (phone != null) {
    const str = String(phone);
    let cleaned = str.replace(/\D/g, ''); // remove non digits
    if (cleaned.indexOf('1') === 0) {
      cleaned = cleaned.substring(1);
    }
    const areaCode = cleaned.substring(0, 3);
    const prefix = cleaned.substring(3, 6);
    const suffix = cleaned.substring(6);

    return `(${areaCode}) ${prefix}-${suffix}`;
  }
  return null;
}
